import { render, staticRenderFns } from "./pi-popup-content.vue?vue&type=template&id=7a64e30c&scoped=true&"
import script from "./pi-popup-content.vue?vue&type=script&lang=js&"
export * from "./pi-popup-content.vue?vue&type=script&lang=js&"
import style0 from "./pi-popup-content.vue?vue&type=style&index=0&id=7a64e30c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a64e30c",
  null
  
)

export default component.exports